import * as React from 'react';
import * as styles from './styles.css';

import { Avatar } from './Avatar';
import { DescriptionRow } from './DescriptionRow';
import { Name } from './Name';
import { Rating } from './Rating';
import { TRealtor } from '../../models/realtor';
import { IModerationInfo, IUserLevelInfo } from '../../models/agent';
import { Counters, ICounter } from './Counters';

interface IAboutBlock {
  label: string;
  text: string;
  action?(): void;
}
export interface IAboutRealtorDesktopProps {
  about: IAboutBlock[];
  avatarUrl: TRealtor['avatarUrl'];
  counters: ICounter[];
  isAvatarRound: boolean;
  isCianPartner: TRealtor['isCianPartner'];
  hasFairplay: TRealtor['hasFairplay'];
  name: TRealtor['name'];
  onDescriptionClick(): void;
  ratingSubtitle: string;
  userLevelInfo?: IUserLevelInfo;
  rate: number;
  hasRgrParticipation: boolean;
  moderationInfo?: IModerationInfo | null;
}

export const AboutRealtorDesktop = (props: IAboutRealtorDesktopProps) => {
  const {
    about,
    avatarUrl,
    counters,
    isAvatarRound,
    isCianPartner,
    hasFairplay,
    name,
    rate,
    ratingSubtitle,
    userLevelInfo,
    hasRgrParticipation,
    moderationInfo,
  } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['row']}>
        <Avatar isRound={isAvatarRound} avatarUrl={avatarUrl} />
        <Name
          hasFairplay={hasFairplay}
          isCianPartner={isCianPartner}
          name={name}
          userLevelInfo={userLevelInfo}
          hasRgrParticipation={hasRgrParticipation}
          moderationInfo={moderationInfo}
        />
      </div>

      <div className={styles['row']}>
        <Rating size="M" text={ratingSubtitle} value={rate} />
        <Counters counters={counters} />
      </div>

      <div className={styles['description-container']}>
        {about.map(({ label, text, action }) => (
          <DescriptionRow key={label} label={label} text={text} action={action} />
        ))}
      </div>
    </div>
  );
};

AboutRealtorDesktop.displayName = 'AboutRealtorDesktop';
